"use strict";

module.exports = class carousel {
	constructor(config) {
		this.config = config;
		this.classes = {
			start: 'is-started',
			end: 'is-end'
		}
	}
	initialize(el) {
		if (document.querySelector(`[data-carousel="${el}"] [data-carousel-dir]`) !== null) {
			this.event(el);
		}
	}
	event(el) {
		let self = this;
		let ul = document.querySelector(`[data-carousel="${el}"] ul`);
		let li = document.querySelectorAll(`[data-carousel="${el}"] li`);

		// On détermine le dernier élémént entièrement visible au départ
		// <=> nb d'items affichés
		let ItemsShow = 0;
		li.forEach((element,index) => {
			if(el === 'suggestion') {
				if (320  * index < ul.getBoundingClientRect().width) {
					ItemsShow++;
				}
			}
			else {
				if (element.getBoundingClientRect().left < ul.getBoundingClientRect().width) {
					ItemsShow++;
				}
			}
		})
		// On met à jour le data
		ul.dataset.carouselLastItemShow = ItemsShow;

		let infoCarousel = {
			ul: ul,
			nbItemsShowed: ItemsShow,
			nbItems: parseInt(ul.dataset.carouselCount)
		}
		// Au click
		document.querySelectorAll(`[data-carousel-controls="${el}"]`).forEach(element => element.addEventListener('click', function (e) {
			if (e.target.dataset.carouselDir === '>') {
				self.slide(infoCarousel, 1)
			} else {
				self.slide(infoCarousel, -1)
			}
		})
		);
	}

	slide(objInfosCarousel, direction) {
		let positionLastVisible = parseInt(objInfosCarousel.ul.dataset.carouselLastItemShow);
		let containerUl = objInfosCarousel.ul.parentElement;
		let newPosition = 0;

		if (direction > 0) {
			/// Update après le click '>'
			/// (on prend la valeur min.)
			objInfosCarousel.ul.dataset.carouselLastItemShow = Math.min(positionLastVisible + objInfosCarousel.nbItemsShowed, parseInt(objInfosCarousel.ul.dataset.carouselCount));

			/// Si le dernier item affiché correspond au dernier item
			/// on ajoute la classe 'is-end'
			/// sinon on retire
			if (parseInt(objInfosCarousel.ul.dataset.carouselLastItemShow) === objInfosCarousel.nbItems) {
				containerUl.classList.add(this.classes.end)
			}

			containerUl.classList.remove(this.classes.start);

			if (positionLastVisible + 1 <= objInfosCarousel.nbItems) {
				newPosition = positionLastVisible + 1;
			}

		} else {
			/// Update après le click '<'
			/// (on prend la valeur max.)
			objInfosCarousel.ul.dataset.carouselLastItemShow = Math.max(positionLastVisible - objInfosCarousel.nbItemsShowed, objInfosCarousel.nbItemsShowed);

			/// Si le premier item affiché est le premier
			/// on ajoute la classe 'is-start'
			/// sinon on retire
			if (parseInt(objInfosCarousel.ul.dataset.carouselLastItemShow) === objInfosCarousel.nbItemsShowed) {
				containerUl.classList.add(this.classes.start);
			}
			containerUl.classList.remove(this.classes.end);

			if (positionLastVisible - objInfosCarousel.nbItemsShowed > 0) {
				newPosition = positionLastVisible - objInfosCarousel.nbItemsShowed - 1;
			}
		}

		try {
			let element = objInfosCarousel.ul.querySelector(`li:nth-of-type(${newPosition})`);
			element.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "start" });
		} catch (e) {
			let element = objInfosCarousel.ul.querySelector(`li:first-of-type`);
			element.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "start" });
			//throw new Error(`Le <li> n°${newPosition} n'existe pas`);
		}
	}
}